import { render } from "./TendenciesTable.vue?vue&type=template&id=463ce42e&scoped=true"
import script from "./TendenciesTable.vue?vue&type=script&lang=js"
export * from "./TendenciesTable.vue?vue&type=script&lang=js"

import "./TendenciesTable.vue?vue&type=style&index=0&id=463ce42e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-463ce42e"]])

export default __exports__